/* eslint-disabled */

export default class DurationExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
